import React from 'react';
import { ArrowForward } from '@mui/icons-material';

const CustomButton = ({ link, title }) => {
  return (
    <a href={link} className="btn-rounded btn btn-primary">
      {title} <ArrowForward fontSize="16" />
    </a>
  );
};

export default CustomButton;
